import API from './ApiParams'

export async function getCategories(){
    const response = await API.get("categories");
    return response.data;
}